// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const quilava: PokeData = {
  "id": 156,
  "name": "quilava",
  "height": 9,
  "weight": 190,
  "base_experience": 142,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "leer",
    "ember",
    "flamethrower",
    "quick-attack",
    "smokescreen",
    "defense-curl",
    "swift",
    "flame-wheel",
    "rollout",
    "eruption",
    "overheat",
    "lava-plume",
    "flame-charge",
    "inferno",
    "burn-up"
  ],
  "moves": [
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "quick-attack",
    "eruption",
    "morning-sun",
    "fire-punch",
    "flare-blitz",
    "magma-storm",
    "fire-ball",
    "sunny-day",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 80,
    "item": null,
    "species": [
      {
        "name": "cyndaquil",
        "order": 187,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quilava",
        "order": 188,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 155,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "typhlosion",
        "order": 189,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 156,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 59.75,
    "speed": 80,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
